module.exports = __webpack_public_path__ + "img/logo-blue-shadow.23196f50.svg";